import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/database";
import "firebase/messaging";
import ft from "../utilities/fieldTracking";
import firebaseConfig from "@/config/firebaseConfig.js";
import loc from "../utilities/location";
import Vue from "vue";
import { EventBus } from "./event-bus";
import huddle from "../utilities/huddle";

var firebaseApp = firebase.initializeApp(firebaseConfig);

var mobile = require("is-mobile");
export const firebaseDB = firebaseApp.database();

// Listen for realtime notification change

if (!mobile()) {
  try {
    var firebaseAnalytics = firebaseApp.analytics();
    var firebaseMessaging = firebaseApp.messaging();
  } catch (e) {
    console.log(e);
  }
}

var fb = {};

fb.state = {};

function registerFcmMessageListener() {
  //   console.log("FCM Message Listner")

  firebaseMessaging
    .getToken()
    .then(fcmToken => {
      dispatch("updateToken", fcmToken);
    })
    .catch(error => {
      console.log("Token Failure ", error);
    });

  firebaseMessaging
    .onTokenRefresh()
    .then(fcmToken => {
      dispatch("updateToken", fcmToken);
    })
    .catch(error => {
      console.log("Token Failure ", error);
    });

  firebaseMessaging.onMessage(payload => {
    console.log("Message received. ", payload);
    // ...

    if (payload.action == "starthuddle") startHuddle(payload);

    checkForRealtime(payload);

    dispatch("getNotifications");
  });
}

function startHuddle(item) {
  console.log("Starting huddle at ", item.url, item.room);
  huddle.start(item.url, item.room, fb.state.userDetails.firstName, fb.state.userDetails.email);
}

fb.init = function(state, dispatch) {
  fb.state = state;
  function checkForRealtime(message) {
    console.log("Message for Realtime  " + JSON.stringify(message));

    if (message.action == "fieldtracking" && message.mode == "pulse") {
      //Get current location and post

      loc.get().then(pos => {
        console.log(typeof pos);
        pos = JSON.parse(pos);
        console.log(typeof pos);
        console.log(pos.coords);
        console.log(pos.coords.latitude);

        console.log("Pulse Received ", `${state.realtimeEndpoint}/pulse`, {
          userId: state.userDetails.id,
          companyId: state.userDetails.companyId,
          gps: { lat: pos.coords.latitude, lng: pos.coords.longitude }
        });

        fetch(`${state.realtimeEndpoint}/pulse`, {
          method: "POST", // or 'PUT'
          headers: {
            "Content-Type": "application/json",
            authorization: state.user.id
          },
          body: JSON.stringify({
            userId: state.userDetails.id,
            companyId: state.userDetails.companyId,
            gps: { lat: pos.coords.latitude, lng: pos.coords.longitude },
            time: new Date().getTime(),
            accuracy: pos.coords.accuracy,
            odo: 0,
            trip: "NA",
            meta: {
              speed: pos.coords.speed,
              heading: pos.coords.heading,
              altitude: pos.coords.altitude
            }
          })
        })
          .then(response => response.json())
          .then(data => {
            console.log("Success:", data);
          })
          .catch(error => {
            console.error("Error:", error);
          });
      });
    }
  }

  if (mobile()) {
    document.addEventListener(
      "deviceready",
      () => {
        window.FirebasePlugin.hasPermission(function(isEnabled) {
          if (!isEnabled) {
            window.FirebasePlugin.grantPermission();
            window.FirebasePlugin.setAnalyticsCollectionEnabled(true);
          }
        });

        window.FirebasePlugin.setUserId(state.userDetails.id);
        window.FirebasePlugin.setUserProperty(
          "name",
          state.userDetails.firstName + state.userDetails.lastName
        );
        window.FirebasePlugin.setUserProperty("email", state.userDetails.email);
        window.FirebasePlugin.setUserProperty("company", state.userDetails.email);
        window.FirebasePlugin.setCrashlyticsCollectionEnabled();

        window.FirebasePlugin.setCrashlyticsUserId(state.userDetails.id);
        window.FirebasePlugin.setAutoInitEnabled(true);

        window.FirebasePlugin.onMessageReceived(
          function(message) {
            console.log("Notification message received", message);
            //    console.log("Message type: " + message.messageType);
            if (message.messageType === "notification") {
              if (message.tap) {
                console.log("Tapped in " + message.tap);
                console.log("message tapped ", message);
                if (message.action == "starthuddle") startHuddle(message);
              }
            }
            dispatch("getNotifications");

            checkForRealtime(message);
            // console.dir(message);
          },
          function(error) {
            console.error(error);
          }
        );

        window.FirebasePlugin.getToken(
          function(fcmToken) {
            dispatch("updateToken", fcmToken);
          },
          function(error) {
            console.error(error);
          }
        );

        window.FirebasePlugin.onTokenRefresh(
          function(fcmToken) {
            dispatch("updateToken", fcmToken);
          },
          function(error) {
            console.error(error);
          }
        );
      },
      false
    );
  } else {
    //   console.log("Firebase Message" , firebaseMessaging)

    firebaseAnalytics.setUserId(state.userDetails.id);
    firebaseAnalytics.setUserProperties(
      "name",
      state.userDetails.firstName + state.userDetails.lastName
    );
    firebaseAnalytics.setUserProperties("email", state.userDetails.email);
    firebaseAnalytics.setUserProperties("company", state.userDetails.email);

    //window.fcm = firebaseMessaging

    Notification.requestPermission()
      .then(() => {
        // User has authorised
        // console.log('User has authorised fcm')
        registerFcmMessageListener();
      })
      .catch(error => {
        // User has rejected permissions
        //  console.log('User has rejected fcm permissions, error = ', error)
        registerFcmMessageListener();
      });
  }
};

fb.listners = function(state, dispatch) {
  console.log("Setting up listners");
  firebaseDB.ref("notification/" + state.userDetails.id).off();
  firebaseDB.ref("notification/" + state.userDetails.id).on("value", snapshot => {
    console.log("Notification change");
    // all records after the last continue to invoke this function
    dispatch("getNotifications");
  });

  firebaseDB.ref("statechange/" + state.userDetails.id).off();
  firebaseDB.ref("statechange/" + state.userDetails.id).on("value", snapshot => {
    console.log("State Change");
    dispatch("getUserData", { userId: state.userDetails.id });
  });

  firebaseDB.ref("companychange/" + state.userDetails.companyId).off();
  firebaseDB.ref("companychange/" + state.userDetails.companyId).on("value", snapshot => {
    console.log("Company Change");

    dispatch("getCompany");
  });
};

fb.log = function(eventName, eventMeta) {
  if (mobile()) {
    window.FirebasePlugin.logEvent(eventName, eventMeta);
  } else {
    firebaseAnalytics.logEvent(eventName, eventMeta);
  }
};

fb.screen = function(screen) {
  if (mobile()) {
    window.FirebasePlugin.setScreenName(screen);
  } else {
    firebaseAnalytics.setCurrentScreen(screen);
  }
};

fb.logout = function() {
  if (mobile()) {
    window.FirebasePlugin.setAutoInitEnabled(false, function() {
      console.log("Auto init has been disabled ");
      window.FirebasePlugin.unregister();
    });
  } else {
    firebaseMessaging.deleteToken();
  }
};

export default fb;
